import { useState } from 'react';
import ScrollReveal from './ScrollReveal';
import ProjectModal from './portfolios/ProjectModal';
import { useTranslation } from 'react-i18next';
import { works } from 'data/portfolioData';
import { getText } from 'utils/getText';

const ScrollPortfolio = () => {
  const { t, i18n } = useTranslation();

  const [selectedProject, setSelectedProject] = useState(null);

  const allowedTypes = ['logo', 'card', 'poster'];

  const projects = works
    .filter((work) => allowedTypes.includes(work.type))
    .flatMap((work) =>
      work.projects.map((project) => ({
        ...project,
        type: work.type,
        category: work.category,
      }))
    );

  /* =====================
     CLICK HANDLER
  ===================== */

  const handleProjectClick = (project) => {
    // card 타입이면 selectedCard 생성
    if (project.type === 'card') {
      setSelectedProject({
        ...project,
        selectedCard: project.cards?.[0], // 핵심
      });
    } else {
      setSelectedProject(project);
    }
  };

  return (
    <section className='px-6 py-10 bg-white md:py-40 md:px-8'>
      <div className='mx-auto max-w-7xl'>
        {/* HEADER */}

        <ScrollReveal>
          <div className='max-w-2xl mb-24'>
            <p
              className='
              text-[11px]
              tracking-[0.28em]
              text-neutral-400
              uppercase
              mb-4
              '
            >
              {t('portfolio.label')}
            </p>

            <h2
              className='
              font-semibold
              leading-tight
              text-[38px]
              sm:text-[50px]
              md:text-[60px]
              tracking-tight
              '
            >
              {t('portfolio.title1')}
              <br />

              <span className='text-[#2F8F6F]'>{t('portfolio.title2')}</span>
            </h2>
          </div>
        </ScrollReveal>

        {/* GRID */}

        <div className='grid max-w-5xl grid-cols-2 gap-2 mx-auto sm:grid-cols-4 md:gap-3'>
          {projects.map((project, index) => (
            <ScrollReveal key={project.id} delay={index * 0.04}>
              <div
                onClick={() => handleProjectClick(project)}
                className='cursor-pointer group'
              >
                {/* CARD */}

                <div className='relative overflow-hidden transition duration-300 ease-out border aspect-square rounded-2xl bg-neutral-100 border-neutral-200 group-hover:-translate-y-1 group-hover:shadow-lg'>
                  {/* IMAGE */}

                  <img
                    src={project.img}
                    alt={getText(project.title, i18n.language, t)}
                    className='object-cover object-top w-full h-full transition duration-500 ease-out group-hover:scale-105'
                  />
                </div>

                {/* INFO */}

                <div className='px-1 mt-3'>
                  <p className='text-sm font-medium tracking-tight text-neutral-900'>
                    {getText(project.title, i18n.language, t)}
                  </p>

                  <p className='mt-1 text-xs text-neutral-500'>
                    {project.year}
                  </p>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>

      {/* MODAL */}

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          onClose={() => setSelectedProject(null)}
        />
      )}
    </section>
  );
};

export default ScrollPortfolio;
